import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from '@/utils/cn';

export type ContainerProps = HTMLAttributes<HTMLDivElement>;

export const Container = forwardRef<HTMLDivElement, ContainerProps>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn('sm:px-6 mx-auto w-full max-w-7xl px-4 lg:px-8', className)}
      {...props}
    />
  ),
);

Container.displayName = 'Container';
